import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { SUPPORT_ROLES } from 'common/utils/user';

export const routes = [
    {
        component: lazy(() => import('module/customer/CustomerListPage')),
        permissions: ['Customer_Read', 'Customer_Create', 'Customer_Edit', 'Customer_Delete'],
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        path: '/',
    },
];
